import React from "react";
import { Descriptions } from "antd";
import { ResourceHomeworkImpact } from "../../types/api/resourceHomeworkImpact";

export type HomeworkImpactCounts = Pick<
  ResourceHomeworkImpact,
  | "homework_count"
  | "classroom_count"
  | "school_count"
  | "student_count"
  | "completed_count"
  | "incomplete_count"
  | "future_scheduled_count"
  | "in_flight_attempt_count"
>;

interface HomeworkImpactDescriptionsProps {
  counts: HomeworkImpactCounts;
  // Extra `Descriptions.Item`s, after the homework counts.
  children?: React.ReactNode;
}

/** The homework counts of a resource or quiz, as an admin sees them at stake. */
const HomeworkImpactDescriptions: React.FC<HomeworkImpactDescriptionsProps> = ({
  counts,
  children,
}) => (
  <Descriptions size="small" column={2} bordered>
    <Descriptions.Item label="Tareas">{counts.homework_count}</Descriptions.Item>
    <Descriptions.Item label="Salones">
      {counts.classroom_count}
    </Descriptions.Item>
    <Descriptions.Item label="Escuelas">{counts.school_count}</Descriptions.Item>
    <Descriptions.Item label="Alumnos">{counts.student_count}</Descriptions.Item>
    <Descriptions.Item label="Resueltas">
      {counts.completed_count}
    </Descriptions.Item>
    <Descriptions.Item label="Pendientes">
      {counts.incomplete_count}
    </Descriptions.Item>
    <Descriptions.Item label="Programadas a futuro">
      {counts.future_scheduled_count}
    </Descriptions.Item>
    <Descriptions.Item label="Intentos en curso">
      {counts.in_flight_attempt_count}
    </Descriptions.Item>
    {children}
  </Descriptions>
);

export default HomeworkImpactDescriptions;
